module.exports = __webpack_public_path__ + "static/media/TvShowBanner (3).00a5982f.png";